var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-community__title" }, [
    _c("h5", [_vm._v(_vm._s(_vm.community.name))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-community__info" },
      [
        _c("img", {
          attrs: {
            src: _vm.$cdn("/img/icons/icon-members.svg"),
            alt: "Community Members",
            width: "24",
            height: "16",
          },
        }),
        _vm._v(" "),
        _c("router-link", {
          attrs: { to: "/" + _vm.$root.community.url + "/members", custom: "" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({
                href,
                route,
                navigate,
                isActive,
                isExactActive,
              }) {
                return [
                  _c("p", [
                    _c(
                      "a",
                      { attrs: { href: href }, on: { click: navigate } },
                      [_vm._v("Members " + _vm._s(_vm.stats.members))]
                    ),
                  ]),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "c-community__info" }, [
      _c("img", {
        attrs: {
          src: _vm.$cdn("/img/icons/icon-likes.svg"),
          alt: "Community Likes",
          width: "17",
          height: "16",
        },
      }),
      _vm._v(" "),
      _c("p", [_vm._v("Likes " + _vm._s(_vm.stats.likes))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-community__info" }, [
      _c("img", {
        attrs: {
          src: _vm.$cdn("/img/icons/icon-views.svg"),
          alt: "Community Views",
          width: "18",
          height: "14",
        },
      }),
      _vm._v(" "),
      _c("p", [_vm._v("Views " + _vm._s(_vm.stats.views))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }